module.exports = __webpack_public_path__ + "img/level2addon_running_gun_shadow.ad8521f4.png";